module.exports = __webpack_public_path__ + "img/company41.5f0dfd34.png";